export const RULES_LIST_LOADER = 'RULES_LIST_LOADER';
